import { Icon } from "@phosphor-icons/react";
import {
  ChatsTeardrop,
  FolderOpen,
  Folders,
  Headset,
  SquaresFour,
  UsersThree,
  WhatsappLogo,
} from "@phosphor-icons/react";
import { ActionType } from "@tgc/types";
import { hasAction, isAdmin } from "../utils/helpers";

export type ComingSoonModalId = "whatsappCampaign" | "whatsappOrders" | "missedCalls" | "emailCampaign";

export type SubRoute = {
  path: string;
  pathName: string;
  hide?: (campaign: any) => boolean;
  indent?: boolean; // Pour indenter les sous-items
  isSectionTitle?: boolean; // Pour les titres de section non cliquables
  comingSoonModal?: ComingSoonModalId;
};

export type NavRoute = {
  path: string;
  pathName: string;
  icon: Icon;
  hide?: (user: any) => boolean;
  subRoutes?: SubRoute[];
  hideChevron?: boolean;
  comingSoonModal?: ComingSoonModalId;
};

const routes: NavRoute[] = [
  {
    path: "/",
    pathName: "nav.home",
    icon: SquaresFour,
    hideChevron: true,
    subRoutes: [
      {
        hide: (campaign) => !hasAction(campaign, ActionType.GOOGLE_REVIEW),
        path: "/google",
        pathName: "nav.stats.google",
      },
      {
        hide: (campaign) => !hasAction(campaign, ActionType.TIKTOK),
        path: "/tiktok",
        pathName: "nav.stats.tiktok",
      },
      {
        hide: (campaign) => !hasAction(campaign, ActionType.FACEBOOK),
        path: "/facebook",
        pathName: "nav.stats.facebook",
      },
      {
        hide: (campaign) => !hasAction(campaign, ActionType.REFERRAL),
        path: "/referral",
        pathName: "nav.stats.referral",
      },
    ],
  },
  {
    path: "/fidelity",
    pathName: "nav.fidelity.title",
    icon: FolderOpen,
    subRoutes: [
      {
        path: "/fidelity/performance",
        pathName: "nav.fidelity.performance",
      },
      {
        path: "",
        pathName: "nav.fidelity.configSection",
        isSectionTitle: true,
      },
      {
        path: "/fidelity/actions",
        pathName: "nav.fidelity.actions",
        indent: true,
      },
      {
        path: "/fidelity/customization",
        pathName: "nav.fidelity.customization",
        indent: true,
      },
      {
        path: "/fidelity/rewards",
        pathName: "nav.fidelity.rewards",
        indent: true,
      },
      // {
      //   path: "/fidelity/promo-codes",
      //   pathName: "nav.fidelity.promoCodes",
      //   indent: true,
      // },
      {
        path: "/fidelity/preview",
        pathName: "nav.fidelity.preview",
      },
      {
        path: "/fidelity/admin",
        pathName: "nav.fidelity.admin",
        hide: (user) => !isAdmin(user),
      },
      // {
      //   path: "/fidelity/distribution",
      //   pathName: "nav.fidelity.distribution",
      // },
    ],
  },
  {
    hide: (user) => !isAdmin(user),
    path: "/demo-campaigns",
    pathName: "nav.campaign.demo-campaigns",
    icon: Folders,
  },
  {
    path: "/reviews",
    pathName: "nav.reviews.title",
    icon: ChatsTeardrop,
    subRoutes: [
      {
        path: "/reviews/management",
        pathName: "nav.reviews.management",
      },
      // {
      //   path: "/reviews/ai-settings",
      //   pathName: "nav.reviews.aiSettings",
      // },
    ],
  },
  {
    path: "/communications",
    pathName: "nav.communications.title",
    icon: Headset,
    subRoutes: [
      // {
      //   path: "/communications/overview",
      //   pathName: "nav.communications.overview",
      // },
      {
        path: "/sms-campaigns",
        pathName: "nav.communications.sms",
      },
      {
        path: "/whatsapp-campaign",
        pathName: "nav.communications.whatsapp",
        comingSoonModal: "whatsappCampaign" as const,
      },
      {
        path: "/email-campaign",
        pathName: "nav.communications.email",
        comingSoonModal: "emailCampaign" as const,
      },
      {
        path: "/communications/missed-calls",
        pathName: "nav.communications.missedCalls",
        comingSoonModal: "missedCalls" as const,
      },
    ],
  },
  {
    // TODO: decide when to hide it
    path: "/orders",
    pathName: "nav.orders.title",
    icon: WhatsappLogo,
    comingSoonModal: "whatsappOrders" as const,
    subRoutes: [
      {
        path: "/orders",
        pathName: "nav.orders.overview",
      },
      {
        path: "/orders/configs",
        pathName: "nav.orders.configuration",
      },
      {
        path: "/orders/chat",
        pathName: "nav.orders.chat",
      },
    ],
  },
  {
    path: "/users",
    pathName: "nav.users",
    icon: UsersThree,
  },
  {
    hide: (user) => !isAdmin(user),
    path: "/admin-players",
    pathName: "nav.adminPlayers",
    icon: UsersThree,
  },
];

export default routes;
